import React, { useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

if (typeof window !== 'undefined' && pdfjs && pdfjs.GlobalWorkerOptions && !pdfjs.GlobalWorkerOptions.workerSrc) {
  pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
}

export default function PdfRenderer({
  src,
  page = 1,
  width,
  onLoadPage,
  onLoadDocument,
}) {
  useEffect(() => {
    if (onLoadPage) onLoadPage(null);
  }, [src, page, onLoadPage]);

  return (
    <Document
      file={src}
      loading={<div style={{ padding: 24, fontSize: 13, color: '#6b7280' }}>Cargando PDF…</div>}
      error={<div style={{ padding: 24, fontSize: 13, color: '#791f1f' }}>No se pudo cargar el PDF.</div>}
      onLoadSuccess={(doc) => {
        if (onLoadDocument) onLoadDocument({ numPages: doc.numPages });
      }}
    >
      <Page
        pageNumber={page}
        width={width}
        renderTextLayer={false}
        renderAnnotationLayer={false}
        onLoadSuccess={(p) => {
          if (onLoadPage) onLoadPage({ width: p.width, height: p.height });
        }}
      />
    </Document>
  );
}
